import { createPortal } from 'react-dom';

import { CloseIcon } from './SvgComponents/CloseIcon';

export const ModalWindow = ({ closeModal, children }) => {
  const portalElem = document.getElementById('portal');

  return createPortal(
    <div className="fixed inset-0 bg-shadowDark w-full h-full flex items-center justify-center z-40">
      <div className="min-w-fit smart:min-w-340 min-h-260 bg-white border-2 rounded-lg p-2.5 relative">
        <button className="w-5 h-5 absolute top-3 right-3 z-40" onClick={closeModal}>
          <CloseIcon />
        </button>
        {children}
      </div>
    </div>,
    portalElem
  );
};
